import { useState } from "react"
import {
    Typography,
    Button,
    Space,
    Card,
    Select,
    Input,
    Upload,
    message,
    Modal,
    Form,
    Collapse,
} from "antd"
import {
    UploadOutlined,
    BugOutlined,
    CustomerServiceOutlined,
    FileTextOutlined,
} from "@ant-design/icons"

const { Title, Text } = Typography
const { Option } = Select
const { Panel } = Collapse

// Helper for Ant Design message
const showMessage = (type, content) => {
    message[type](content)
}

const HelpSupport = () => {
    const [isSubmitTicketModalVisible, setIsSubmitTicketModalVisible] = useState(false)
    const [ticketForm] = Form.useForm()

    const handleSubmitTicket = (values) => {
        showMessage("success", "Ticket submitted successfully!")
        setIsSubmitTicketModalVisible(false)
        ticketForm.resetFields()
    }

    return (
        <Card className="mb-6">
            <div className="mb-4">
                <Title level={4}>Help & Support</Title>
                <Text type="secondary">Get assistance, report bugs, or contact the Radar+ team.</Text>
            </div>

            <Title level={5} className="mb-4">
                Quick Actions
            </Title>
            <Space wrap className="mb-6">
                <Button icon={<FileTextOutlined />} onClick={() => window.open("https://docs.example.com", "_blank")}>
                    Open Help Center →
                </Button>
                <Button icon={<BugOutlined />} onClick={() => showMessage("info", "Opening feedback form...")}>
                    Report a Bug →
                </Button>
                <Button icon={<CustomerServiceOutlined />} onClick={() => setIsSubmitTicketModalVisible(true)}>
                    Contact Support →
                </Button>
            </Space>

            <Modal
                title="Submit a Ticket"
                visible={isSubmitTicketModalVisible}
                onCancel={() => setIsSubmitTicketModalVisible(false)}
                footer={null}
            >
                <Form form={ticketForm} onFinish={handleSubmitTicket} layout="vertical">
                    <Form.Item name="subject" label="Subject" rules={[{ required: true, message: "Please enter a subject!" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="Description"
                        rules={[{ required: true, message: "Please enter a description!" }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item name="priority" label="Priority" initialValue="medium">
                        <Select>
                            <Option value="low">Low</Option>
                            <Option value="medium">Medium</Option>
                            <Option value="high">High</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="attachment" label="Attach File">
                        <Upload beforeUpload={() => false} maxCount={1}>
                            <Button icon={<UploadOutlined />}>Select File</Button>
                        </Upload>
                    </Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form>
            </Modal>

            <Title level={5} className="mb-4">
                FAQ or Popular Topics
            </Title>
            <Collapse accordion className="mb-6">
                <Panel header="How does Radar+ define a signal?" key="1">
                    <p>
                        Radar+ defines a signal as a detected event or pattern that meets your configured urgency, impact, and
                        confidence thresholds, indicating a potential risk or opportunity.
                    </p>
                </Panel>
                <Panel header="What happens when auto-execution is paused?" key="2">
                    <p>
                        When auto-execution is paused, Radar+ will continue to detect signals and suggest actions, but no tasks will
                        be automatically executed without manual approval.
                    </p>
                </Panel>
                <Panel header="How do I export my data?" key="3">
                    <p>
                        You can export your data from the "Backup & Export" section, choosing between JSON or YAML formats, and
                        optionally including system logs.
                    </p>
                </Panel>
            </Collapse>

            <Button type="link" className="p-0" onClick={() => window.open("https://status.radarplus.ai", "_blank")}>
                View Radar+ system uptime and historical incidents → status.radarplus.ai
            </Button>
        </Card>
    )
}

export default HelpSupport;